import PropTypes from 'prop-types';
import {createUseStyles, useTheme} from 'react-jss';
import {connect} from 'react-redux';
import loadArtemisFonts from '../../../v2/components/ui/loadArtemisFonts';
import Translation from '../../../v2/lang/Translation';
import {getOptimalDeliveryOption} from '../../../v2/selectors/DeliveryOptionsSelectors/DeliveryOptionsSelectors';
import isUsingArtemisStyles from '../../../v2/selectors/isUsingArtemisStyles';
import Typography from '../../../v2/style-helper/Typography';
import replaceHTMLEntityWithSymbol from '../../../v2/utils/replace-html-entity-with-symbol';
import DeliveryOptionPricePropType from '../../../propTypes/DeliveryOptionPrice.proptype';

const useStyles = createUseStyles({
  deliveryOptionPriceStyled: props => ({
    fontFamily: props.theme.deliveryOptions.priceFontFamily,
    fontSize: props.theme.deliveryOptions.priceFontSize,
    fontWeight: props.theme.deliveryOptions.priceFontWeight,
    ...(props.isUsingArtemisStyles && props.theme.typography?.[Typography.medium])
    && loadArtemisFonts(props.theme.typography[Typography.medium]),
    color: '#008814',
  }),
  originalPrice: {
    color: '#333',
    textDecoration: 'line-through',
    fontWeight: 400,
  },
  freeDelivery: {
    textTransform: 'uppercase',
  },
});

export function DeliveryOptionPrice(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  return (
    <span className={`DeliveryOptionPrice ${classes.deliveryOptionPriceStyled}`}>
      {props.isDiscounted && (
        <>
          <span className={classes.originalPrice} data-test="DeliveryOptionPrice__originalPrice">
            {props.price}
          </span>
          {' '}
        </>
      )}
      {props.isFreeDelivery
        ? (
          <span className={classes.freeDelivery} data-test="DeliveryOptionPrice__freeDelivery">
            <Translation>messages.delivery.freeDelivery</Translation>
          </span>
        ) : props.discountedPrice}
      {props.taxable && (
        <span className="DeliveryOptionPrice__taxValue">
            {' + '}
          {props.tax}
          {' '}
          <Translation>deliveryOptions.import.tax.descriptor</Translation>
        </span>
      )}
    </span>
  );
}

DeliveryOptionPrice.propTypes = {
  taxable: PropTypes.bool.isRequired,
  isFreeDelivery: PropTypes.bool.isRequired,
  isDiscounted: PropTypes.bool.isRequired,
  discountedPrice: DeliveryOptionPricePropType,
  price: DeliveryOptionPricePropType,
  tax: DeliveryOptionPricePropType,
  isUsingArtemisStyles: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => {
  const optimalDeliveryOption = getOptimalDeliveryOption(state);
  const deliveryIncluded = !ownProps.isOptionalGroup
    && optimalDeliveryOption?.price >= (ownProps.price.amount || ownProps.price.value)
    && ownProps.groupId !== optimalDeliveryOption.groupId;
  const valueToDisplay = deliveryIncluded ? 0 : ownProps.discountedPrice.value;
  
  return {
    discountedPrice: replaceHTMLEntityWithSymbol(ownProps.discountedPrice.formatted),
    price: replaceHTMLEntityWithSymbol(ownProps.price.formatted),
    tax: ownProps.taxPrice && replaceHTMLEntityWithSymbol(ownProps.taxPrice.formatted),
    isDiscounted: ownProps.price.value !== valueToDisplay,
    isFreeDelivery: valueToDisplay === 0,
    isUsingArtemisStyles: isUsingArtemisStyles(state),
  };
};

export default connect(mapStateToProps)(DeliveryOptionPrice);
